import React from 'react';
import { useCssHandles } from '../../../utils/functions';
import { ListContextProvider } from '../../list-context/ListContextProvider';
import { useCompreJunto } from '../hooks/useCompreJunto';
import BuyTogetherBuyBox from './BuyTogetherBuyBox';
import BuyTogetherSelectableBox from './BuyTogetherSelectableBox';
const CSS_HANDLES = [
	'buyTogether',
	'buyTogetherWrapper',
	'buyTogetherTitleContainer',
	'buyTogetherTitle',
	'buyTogetherBuyCard',
	'buyTogetherBuyCardTitle',
	'buyTogetherBuyCardPrice',
	'buyTogetherBuyCardListPrice',
	'buyTogetherBuyCardSellingPrice',
	'buyTogetherBuyCardSubtitle',
	'buyTogetherBuyCardSavePrice',
	'buyTogetherBuyCardSavePriceCount',
	'buyTogetherBuyCardSavePriceValue',
	'buyTogetherBuyCardSubtitleSavePrice',
	'buyTogetherBuyCardSubtitleSellingPrice',
	'buyTogetherBuyCardButton',
	'buyTogetherBuyCardButtonLoading',
	'buyTogetherBuyCardButtonDisabled',
	'buyTogetherBuyCardButtonIcon',
	'buyTogetherBuyCardButtonText',
	'buyTogetherBuyCardButtonNumber',
	'buyTogetherBuyCardInstallment',
];

type CompreJuntoContainerProps = { children: React.ReactNode };

function CompreJuntoContainer({ children }: CompreJuntoContainerProps): JSX.Element {
	const { blockClass, blocks } = useCompreJunto();

	const { handles }: any = useCssHandles('maeztraio-buy-together-1-x', CSS_HANDLES, blockClass);
	const context = useCompreJunto();

	const { title, maxItems, showSelectableBoxes } = context;
	const blockArr: JSX.Element[] = Array(...Array(maxItems)).map(() => blocks[0]);

	return (
		<div className={`${handles.buyTogether} flex flex-column justify-center items-center mb4 w-100 t-body`}>
			<div className={`${handles.buyTogetherTitleContainer} flex w-100`}>
				<h1 className={`${handles.buyTogetherTitle} c-action-primary tc w-100 mt0 mb5`}>{title}</h1>
			</div>
			<div
				className={`${handles.buyTogetherWrapper} flex flex-column flex-row-l justify-center items-center w-100 mb9 mb10-l`}
			>
				{/* A lista abaixo foi feita assim somente para aparecerem os selectables no hefesto */}
				<ListContextProvider
					list={blockArr.map((block) => (
						<div>
							{' '}
							{block}
							{showSelectableBoxes ? <BuyTogetherSelectableBox {...context} handles={handles} /> : null}
						</div>
					))}
				>
					{children}
				</ListContextProvider>

				<BuyTogetherBuyBox {...context} handles={handles} />
			</div>
		</div>
	);
}

export default CompreJuntoContainer;

// caso queira que o  BuyTogetherSelectableBox reinderize no produto final, é necessario colocar o
// "buy-together-selectable-box" como children da prateleira do buyTogether
// aconselhavel duplicar a prateleira original e criar uma apenas para o buy together
// EX:
// "product-summary.shelf#buy-together": {
//    "title": "Sumário do produto",
//    "children": [
//        // "product-summary.shelf#shelf-ProductSummaryShelf-1"
//        "add-to-list-btn#shelf-Wishlist-1",
//        "flex-layout.row#shelf-FlexLayoutRow-1",
//        "buy-together-selectable-box"
//    ],
//    "props": {
//        "blockClass": [
//            "product__summary",
//            "product__summary--shelf",
//            "product__summary--buy-together"
//        ],
//        "priceBehavior": "default",
//        "trackListName": true
//    }
// },
